/* istanbul ignore file */
import "./index.scss";

import { Suspense } from "react";
import { Provider } from "react-redux";

import App from "App";
import store from "store";

import { createRoot } from "react-dom/client";

import * as serviceWorker from "./config/serviceWorker";

const Root = (
  <Suspense fallback={null}>
    <Provider store={store}>
      <App />
    </Provider>
  </Suspense>
);

const rootElement = document.getElementById("root");
if (rootElement) {
  createRoot(rootElement).render(Root);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
